/* eslint-disable prettier/prettier */
import React, {useState} from 'react';
import PlayersFilter from "./Filters/PlayersFilter";
import PlayersTable from "./Tables/PlayersTable";
import {usePlayersStats} from "../../hooks/playerStats";
import {usePlayerFilterOptions} from "./FilterOptions/PlayerFilterOptions";

function Players({ show }) {
    if (!show) return null;
    history.pushState({urlPath:'/statistik/spelare'},"",'/statistik/spelare');
    const [orderBy, setOrderBy] = useState('goals');
    const [season, setSeason] = useState(currentSeason);
    const [team, setTeam] = useState('Alla lag');
    const [playerLimit, setPlayerLimit] = useState(20);
    const [nationality, setNationality] = useState('Alla nationaliteter');
    const [position, setPosition] = useState('Alla positioner');
    const [playersStats, playersStatsLoading, playersStatsError] = usePlayersStats(season);
    const [playerFilterOptions, loadingPlayerFilterOptions, errorPlayerFilterOptions] = usePlayerFilterOptions();
    const tableName = playerFilterOptions?.map((option) => {
        if (option.key === orderBy && option.key !== '') {
            return option.name
        }
    });
    return (
        <div className="row">
            <div className="col-12">
                <div className="data-container no-radius-top">
                    <PlayersFilter
                        playersStats = {playersStats}
                        setSeason={setSeason}
                        season={season}
                        orderBy={orderBy}
                        setOrderBy={setOrderBy}
                        team={team}
                        setTeam={setTeam}
                        position={position}
                        setPosition={setPosition}
                        nationality={nationality}
                        setNationality={setNationality}
                        playerLimit={playerLimit}
                        setPlayerLimit={setPlayerLimit}
                    />
        <div className="data-container">
            <div className="bg-primary-blue">
                <p className="h4 mb-0" style={{padding: "15px 15px 11px 15px"}}>{tableName} {season}</p>
            </div>
            <div className="stats-table">
                <div className="stats-table__row d-none d-md-flex" style={{minHeight: "54px"}}>
                    <div className="col-1 col-md-1 heading-stats-name text-center">
                        Ranking
                    </div>
                    <div className="col-9 col-md-3 heading-stats-name">
                        Spelare
                    </div>
                    <div className="col-auto col-md-2 d-none d-md-block heading-stats-name">
                        Lag
                    </div>
                    <div className="col-auto col-md-2 d-none d-md-block heading-stats-name">
                        Position
                    </div>
                    <div className="col-auto col-md-2 d-none d-md-block heading-stats-name">
                        Nationalitet
                    </div>
                    <div className="col-auto col-md-1 heading-stats-name d-none d-md-block text-center">
                        Antal matcher
                    </div>
                    <div className="col-2 col-md-1 heading-stats-name text-center">
                        {tableName}
                    </div>
                </div>
                    <PlayersTable
                        playersStats = {playersStats}
                        playersStatsLoading = {playersStatsLoading}
                        playerLimit={playerLimit}
                        setPlayerLimit={setPlayerLimit}
                        season={season}
                        orderBy={orderBy}
                        team={team}
                        position={position}
                        nationality={nationality}
                    />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Players;